import React, { useState } from "react";
import striptags from "striptags";
import AnchorLink from "react-anchor-link-smooth-scroll";
import Link from "next/link";
import Image from "next/image";

const ServiceTabs = ({ data }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  return (
    <section className="service-tabs-section">
      <div className="service-tabs-inner">
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-md-4">
              <div className="service-left-tabs">
                <ul>
                  {data &&
                    data?.map((val, i) => {
                      if (val?.type == "services_list") {
                        return (
                          <React.Fragment key={`${i}_j`}>
                            {val?.value?.list?.map((val, index) => {
                              return (
                                <li key={index}>
                                  <AnchorLink
                                    offset={() => 120}
                                    href={`#${index}`}
                                    className={`service-tab-link ${
                                      activeIndex == index ? "active" : ""
                                    }`}
                                    dangerouslySetInnerHTML={{
                                      __html: val?.value?.title,
                                    }}
                                    onClick={() => {
                                      setActiveIndex(index);
                                    }}
                                  ></AnchorLink>
                                </li>
                              );
                            })}
                          </React.Fragment>
                        );
                      }
                    })}
                </ul>
              </div>
            </div>
            <div className="col-lg-9 col-md-8">
              <div className="service-tabs-right">
                <div className="service-tabs-content">
                  {data &&
                    data?.map((val, i) => {
                      if (val?.type == "services_list") {
                        return (
                          <React.Fragment key={`${i}_j`}>
                            {val?.value?.list?.map((val, index) => {
                              const titleWithoutPTag = striptags(
                                val?.value?.title,
                                "<span>"
                              );
                              return (
                                <div
                                  className="service-feature-card"
                                  id={index}
                                >
                                  <div className="row">
                                    <div className="col-lg-6">
                                      <div className="service-heading">
                                        <h2>
                                          <span
                                            itemProp="heading"
                                            dangerouslySetInnerHTML={{
                                              __html: titleWithoutPTag,
                                            }}
                                          ></span>
                                        </h2>
                                      </div>
                                      <div
                                        className="service-short-description"
                                        dangerouslySetInnerHTML={{
                                          __html: val?.value?.description,
                                        }}
                                      ></div>
                                      <div className="service-feature-btn">
                                        <Link
                                          href={`/services/${val?.value?.page_chooser_block?.page?.slug}`}
                                          className="btn btn-primary"
                                          itemProp="link"
                                        >
                                          {
                                            val?.value?.page_chooser_block
                                              ?.title
                                          }
                                        </Link>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div className="service-feature-image">
                                        <div className="service-img-box">
                                          <div className="service-img-label">
                                            <Image
                                              height={500}
                                              width={500}
                                              src={
                                                val?.value?.image_box?.image
                                                  ?.url
                                              }
                                              alt={val?.value?.image_box?.image
                                                ?.alt_text ?? 'python'}
                                              loading="eager"
                                            />
                                            <span>
                                              {val?.value?.image_box?.title}
                                            </span>
                                          </div>
                                          <Image
                                            height={400}
                                            width={400}
                                            src={val?.value?.image?.url}
                                            alt={val?.value?.image?.alt_text ?? 'python'}
                                            className="service-thumbnail-img"
                                            loading="eager"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                          </React.Fragment>
                        );
                      }
                    })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceTabs;
